<style scoped lang="scss">
@media
screen and (max-width: 375px) and (min-width: 374px),
screen and (min-width: 300px) and (max-width:400px){
  .wrap-compose .service{
    margin-top: 10px!important;
  }
}
@media screen and (max-width: 414px) and (min-width: 413px){
  .wrap-compose .service{
    margin-top: 10px!important;
  }
}
@media screen and (max-width: 640px) and (min-width: 600px){
  .wrap-compose .service{
    margin-top: 10px!important;
  }
}
  .wrap-compose{
    .banner{
      position: relative;
      .info{
        position: absolute;
        top:0;
        width:100%;
        height:100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        h1{
          font-size: 46px;
          color:#fff;
        }
      }
      .classify{
        padding:20px;
        background: rgba(255,255,255,.9);
        width: 200px;
        height:300px;
        position: absolute;
        left:calc((100vw - 1200px) / 2);
        top:50%;
        transform: translateY(-50%);
        z-index: 9;
        .title{
          padding-bottom: 10px;
          margin-bottom: 20px;
          font-size: 16px;
          font-weight: bold;
          border-bottom: 1px solid #E4E6EA;
        }
        a{
          color:#333;
          &.active{
            color:#014492;
          }
        }
        li{
          margin-bottom: 20px;
        }
      }
    }
    .map{
      width:940px;
    }
    .service{
      //background: #F6FAFD;
      padding-bottom:50px;
      margin-top: 20px;
      ul{
        display: flex;
        justify-content: space-around;
        padding:0 10%;
      }
      .c-title{
        padding-top: 60px;
      }
    }
    .mr41{
      display: block;
    }
    .mr42{
      display: none;
    }
  }
  @media screen and (max-width: 640px){
    .tc img{
      width: 90%;
      margin:0 auto;
    }
    .mr42{
      margin-left: auto;
      margin-right: auto;
      display: block!important;
    }
    .mr41{
      display: none!important;
    }
    .wrap-compose .service ul{
      display: block!important;
    }
    .wrap-compose .service ul li{
      margin-left: auto;
      width: -moz-fit-content;
      width: fit-content;
      margin-right: auto;
    }
    .container{
      width: 90% !important;
      font-size: 12px!important;
    }
    .container p{
      line-height: 25px;
    }
    .wrap-compose .banner .info h1{
      font-size: 25px!important;
    }
    .c-title{
      padding: 20px 0 20px!important;
      font-size: 24px!important;
    }
  }
</style>
<style lang="scss">
.method-table{
  margin:auto;
  th{
    height:76px;
  }
  td{
    height: 100px;
  }
}
</style>
<template>
  <!--  DNA合成-->
  <div class="wrap wrap-compose">
    <div class="banner">
      <img src="@/assets/images/banner_1.png" class="img-fluid" alt="DNA合成">
      <div class="container info">
        <h1>DNA合成</h1>
        <el-button class="mt20 mr42" size="mini" @click="$router.push('/tec/order_primer')">立即合成</el-button>
        <el-button class="mt20 mr41"  @click="$router.push('/tec/order_primer')">立即合成</el-button>
      </div>
      <div class="classify">
        <div class="title">寡核苷酸合成</div>
        <ul>
          <li><router-link to="/tec/compose1" class="active">DNA合成</router-link></li>
          <!-- <li><router-link :to="handleJumpPath('/tec/compose2')">修饰引物/探针合成</router-link></li> -->
          <li><router-link :to="handleJumpPath('/tec/compose3')">RNA合成</router-link></li>
<!--          <li><router-link to="">探针设计</router-link></li>-->
        </ul>
      </div>
    </div>
    <div>
      <div class="container breads" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;margin-top: 20px;">
        <bread></bread>
      </div>

    </div>
    <div class="service">
      <en-title title="服务特色" />
      <p class="title-desc">
        全国20余生产基地，驻地服务保障次日达，部分城市可提供当日达服务；引入CE毛细管电泳定期质检，保证质量稳定；高度自动化合成，保证批间稳定。      
      </p>
      <div class="container con">
        <ul>
          <li>
            <img src="@/assets/images/service_icon_1.png" alt="擎科生物-DNA合成-服务优势-圆点标签
">
            <p>圆点标签</p>
          </li>
          <li>
            <img src="@/assets/images/service_icon_2.png" alt="擎科生物-DNA合成-服务优势-液体引物
">
            <p>液体引物</p>
          </li>
        </ul>
      </div>
    </div>
    <div>
      <en-title title="纯度级别选择指南" />
      <div class="container con1">
        <el-table
          border
          class="method-table"
          :data="tableData">
          <el-table-column
            prop="method"
            label="纯度级别">
          </el-table-column>
          <el-table-column
            label="5～20mer">
            <template slot-scope="scope">
              <span :class="{'text-primary':scope.row.scale1 === '推荐', 'text-gray9': scope.row.scale1 === '不适用'}">{{scope.row.scale1}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="40～61mer">
            <template slot-scope="scope">
              <span :class="{'text-primary':scope.row.scale2 === '推荐', 'text-gray9': scope.row.scale2 === '不适用'}">{{scope.row.scale2}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="61～90mer">
            <template slot-scope="scope">
              <span :class="{'text-primary':scope.row.scale3 === '推荐', 'text-gray9': scope.row.scale3 === '不适用'}">{{scope.row.scale3}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="91～150mer">
            <template slot-scope="scope">
              <span :class="{'text-primary':scope.row.scale4 === '推荐', 'text-gray9': scope.row.scale4 === '不适用'}">{{scope.row.scale4}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="application"
            width="500"
            label="应用">
          </el-table-column>
        </el-table>
        <p class="fb mb10 mt20">服务说明：</p>
        <p>未注明合成量，我们将按照总量2 OD。</p>
        <p>兼并碱基按照常规引物收费。</p>
        <p>引物&lt;15 mer的按条收费，引物> 59 mer的按长链收费。</p>
        <p>修饰引物价格计算方式：总价=常规引物价格+修饰价格。</p>
        <p>兼并引物对应：R=G/A、Y=C/T 、W=A/T 、S=C/G 、M=A/C、 B=C/G/T 、D=A/G/T、 H=A/C/T 、V=A/C/G、 N=A/C/G/T</p>
      </div>
      <en-title title="案例" />
      <p class="title-desc">
        对常用的20 nt、30 nt 、40 nt引物进行随机质谱抽检，检测图峰型单一，代表引物纯度高。      
      </p>
      <div class="tc">
        <img style="max-width: 1250px;width: 100%;" src="@/assets/images/DNA_case.png"/>
      </div>
      <en-title title="全国合成实验室" />
      <div class="tc">
        <img src="@/assets/images/compose_new_map.png" alt="擎科生物-全国引物合成实验室
">
      </div>
    </div>
    <div></div>
    <!-- 订购与咨询 -->
    <div class="container">
        <new-consult type="primer" enTitle="" phoneNumber="400-668-3730 转2" :typeList="['orderOnline','telePhone','download','email']"></new-consult>
    </div>
    <!-- <qk-consult type="primer"/> -->
  </div>
</template>

<script>
import bread from "@/components/bread"
export default {
  components:{
    bread
  },
  data() {
    return {
      tableData: [{
        method: 'OPC',
        scale1: '适用',
        scale2: '推荐',
        scale3: '适用',
        scale4: '不适用',
        application: 'PCR扩增、亚克隆、点突变、基因合成、DNA测序'
      }, {
        method: 'PAGE',
        scale1: '适用',
        scale2: '推荐',
        scale3: '适用',
        scale4: '适用',
        application: '对于40 mer以上的普通引物纯化，用于点突变、克隆、蛋白凝胶迁移电泳分析'
      }, {
        method: 'HPLC',
        scale1: '推荐',
        scale2: '适用',
        scale3: '不适用',
        scale4: '不适用',
        application: '小于50 mer的普通引物纯化，上述应用及修饰引物的纯化，商业化的诊断引物或者探针'
      }]
    }
  },
  methods: {
    handleJumpPath(path) {
      let queryPath = ''
      if(this.$route.path === '/tec/compose1') {
        queryPath = 'product=true'
      }
      Object.entries(this.$route.query).forEach(([key = '', value = '']) => {
        queryPath += `${key}=${value}`
      })
      return `${path}?${queryPath}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/tec/compose_1.vue